__turbopack_context__.v({
  "bar": "LeaderboardStickyBar-module__-D6QdW__bar",
  "barInner": "LeaderboardStickyBar-module__-D6QdW__barInner",
  "compactTitle": "LeaderboardStickyBar-module__-D6QdW__compactTitle",
  "innerDesktop": "LeaderboardStickyBar-module__-D6QdW__innerDesktop",
  "innerMobile": "LeaderboardStickyBar-module__-D6QdW__innerMobile",
  "toggleSlot": "LeaderboardStickyBar-module__-D6QdW__toggleSlot",
});
